import { globalConstants } from "../constants";
import {
  putRequest,
  postRequest,
  deleteRequest,
  getRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function paymentCheckout(paymentData) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment`,
    paymentData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function paymentCheckoutSavedCard(paymentData) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/savedCard/checkout`,
    paymentData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function paymentHistory(paymentData) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/history`,
    paymentData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function paymentHistoryStats(paymentData) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/history/stats`,
    paymentData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function adminPaymentHistory(gridState) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/admin/history`,
    gridState,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function exportPaymentHistory(gridState) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/export/history`,
    gridState,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function saveCard(checkoutId) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/saveCard/${checkoutId}`,
    null,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function getSavedPaymentCard(id) {
  return postRequest(
    `/${globalConstants.VERSION}/Payment/savedCards`,
    id,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function deleteCard(cardId) {
  return deleteRequest(
    `/${globalConstants.VERSION}/Payment/DeleteCard/${cardId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}
async function updateSavedCard(id) {
  return putRequest(
    `/${globalConstants.VERSION}/Payment/UpdateCard/${id}/true`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const paymentService = {
  paymentCheckout,
  paymentHistory,
  paymentHistoryStats,
  adminPaymentHistory,
  exportPaymentHistory,
  getSavedPaymentCard,
  saveCard,
  deleteCard,
  updateSavedCard,
  paymentCheckoutSavedCard,
};
